// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1b9-Z","header":"Messages_header__b2Yq3"};